module.exports = __webpack_public_path__ + "assets/images/USDUNFIT100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDUNFIT100.png
// module id = 1467
// module chunks = 1